module.exports = "<div class=\"container\">\n  <div user-summary=\"ctrl.email\" user-uuid=\"ctrl.uuid\"></div>\n</div>";